import { Box } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ConfigureNode } from '.';
import { filterConfigurationApiHash, getPrioritizedItem } from '../../../../utils/configurationApi';
import TableFilter from '../configurationApiBlock/configurationApiTable/components/TableFilter';

const ConfigureNodeWrapper = ({ treeHash, hash, onHashChange }) => {
  const [filteredTreeHash, setFilteredTreeHash] = useState([]);

  const sortedKeys = useMemo(() => {
    return Object.keys(filteredTreeHash).sort((a, b) => {
      const first = filteredTreeHash[a].items ? getPrioritizedItem(filteredTreeHash[a].items) : filteredTreeHash[a];
      const second = filteredTreeHash[b].items ? getPrioritizedItem(filteredTreeHash[b].items) : filteredTreeHash[b];
      return first.name.localeCompare(second.name);
    });
  }, [filteredTreeHash]);

  const filterTreeHash = useCallback((filter) => {
    const filteredTreeHash = filterConfigurationApiHash(treeHash, filter, hash);
    for (let league of Object.values(filteredTreeHash)) {
      league.isCollapsed = !!filter;
    }
    setFilteredTreeHash(filteredTreeHash);
  }, [treeHash, hash]);

  const handleToggleCollapse = useCallback((key) => {
    const newTreeHash = { ...filteredTreeHash };
    newTreeHash[key].isCollapsed = !newTreeHash[key].isCollapsed;
    setFilteredTreeHash(newTreeHash);
  }, [filteredTreeHash]);

  useEffect(() => {
    setFilteredTreeHash(treeHash);
  }, [treeHash]);

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', marginTop: '49px', gap: '10px', padding: '24px' }}>
      <TableFilter delay={300} onChange={(value) => filterTreeHash(value)} />
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        {sortedKeys.map((item) => (
          <ConfigureNode
            key={item}
            item={filteredTreeHash[item]}
            hash={hash}
            level={2}
            onHashChange={onHashChange}
            parentId={null}
            toggleCollaps={() => handleToggleCollapse(item)}
          />
        ))}
      </Box>
    </Box>
  );
}

export default ConfigureNodeWrapper;
